import {
    type MarkAsReadRequestType,
    type MarkAsReadResponseType
} from "./types";
import axios from "axios";
import {
    SERVER_ADDRESS
} from "../../constants";
import {
    getHeaders
} from "../../utils";

const MarkAsRead = async (params: MarkAsReadRequestType): Promise<MarkAsReadResponseType> => {
    return await axios(`${SERVER_ADDRESS}/notification/markAsRead`, {
        headers: getHeaders(true),
        method: "POST",
        data: params
    })
        .then((res) => {
            if (
                res.status === 200 ||
                res.status === 201 ||
                res.status === 202
            ) {
                return res.data;
            }

            throw res;
        })
        .catch((err) => {
            if (err && err.response && err.response.data) {
                throw err.response.data;
            }

            throw err;
        });
};

export default MarkAsRead;
